<template>
  <div v-loading="isLoading" class="paper-analysis-page">
    <FullTxtArtAnalysisResultWorkBench :full_txt_art_analysis_data="fullTxtArtAnalysisData" @clossPaperAnalysis="goHome" style="width: 100%; height: 100%" />
  </div>
</template>

<script>
/* eslint-disable */
import FullTxtArtAnalysisResultWorkBench from "../components/FullTxtArtAnalysisResultWorkBench.vue";

export default {
  name: "FullTxtArtAnalysisResultPage",
  components: {
    FullTxtArtAnalysisResultWorkBench,
  },
  data() {
    return {
      isLoading: false,
      fullTxtArtAnalysisData: {},
    };
  },
  watch: {
    "$route.fullPath"() {
      this.loadResultData();
    },
  },
  mounted() {
    this.loadResultData();
  },
  methods: {
    async loadResultData() {
      const { conversation_id, data_ruid, file_name, is_create_task } = this.$route.query;

      if (!conversation_id && !data_ruid) {
        this.goHome();
        return;
      }

      this.isLoading = true;
      this.fullTxtArtAnalysisData = {};
      try {
        if (conversation_id) {
          const res = await this.$http.get(this.globalUrl.cxai_conversation_select_one, {
            params: { conversation_id },
          });
          const convData = res.data?.conv_data || {};
          const convType = res.data?.conv_type;

          if (convType === "task" && convData.type === "full_txt_art_analysis" && convData.result) {
            this.fullTxtArtAnalysisData = convData.result;
          } else {
            this.fullTxtArtAnalysisData = {};
          }
        } else {
          const res = await this.$http.get(this.globalUrl.full_txt_art_analysis, {
            params: {
              data_ruid,
              file_name: file_name || "",
              is_create_task: is_create_task === "true" || is_create_task === "1",
            },
          });
          this.fullTxtArtAnalysisData = res.data || {};
        }
      } catch (error) {
        this.fullTxtArtAnalysisData = {};
      } finally {
        this.isLoading = false;
      }
    },
    goHome() {
      sessionStorage.removeItem("full_txt_art_analysis_back_context");
      if (window) {
        history.replaceState(null, "", "/asp/literature_analysis");
        const popStateEvent = new PopStateEvent("popstate", { state: null });
        window.dispatchEvent(popStateEvent);
      } else {
        this.$router.push({ path: "/ai_home" }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.paper-analysis-page {
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  background-color: var(--bg-back);
}
</style>
